import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard2');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard2',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard2/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.d2-shell {
  --d2-navy-950: #071426;
  --d2-navy-900: #0b1d36;
  --d2-navy-800: #132d50;
  --d2-blue-700: #125fc2;
  --d2-blue-600: #1674d8;
  --d2-blue-100: #eaf3ff;
  --d2-ink: #162236;
  --d2-text: #556379;
  --d2-muted: #8792a5;
  --d2-line: #dce3ec;
  --d2-line-soft: #e9edf3;
  --d2-canvas: #f5f7fa;
  --d2-surface: #ffffff;
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  background: var(--d2-surface);
  color: var(--d2-ink);
  font-family: Inter, "Pretendard Variable", Pretendard, "Noto Sans KR", sans-serif;
}

button,
input {
  font: inherit;
}

button {
  cursor: pointer;
}

.d2-notice {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  margin: 16px 24px;
  border: 1px solid #cfdceb;
  border-left: 3px solid var(--d2-blue-600);
  background: #f7faff;
  padding: 11px 14px;
  color: var(--d2-blue-700);
}

.d2-notice strong,
.d2-notice p {
  margin: 0;
}

.d2-notice strong {
  color: var(--d2-ink);
  font-size: 13px;
}

.d2-notice p {
  margin-top: 2px;
  color: var(--d2-text);
  font-size: 12px;
}

.d2-notice button {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  gap: 6px;
  border: 1px solid #c8d6e7;
  border-radius: 10px;
  background: #ffffff;
  padding: 0 11px;
  color: var(--d2-blue-700);
  font-size: 12px;
  font-weight: 700;
}

.d2-hero {
  position: relative;
  display: flex;
  min-height: 390px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: linear-gradient(90deg, rgba(4, 16, 35, 0.84) 0%, rgba(5, 22, 48, 0.82) 48%, rgba(3, 18, 41, 0.72) 100%), linear-gradient(180deg, rgba(4, 16, 34, 0.12) 35%, rgba(3, 14, 31, 0.62) 100%), url("/assets/dashboard/agent-data-hero.png") center 58%/cover no-repeat;
  padding-block: 50px;
  padding-inline: max(68px, (100% - 1200px) / 2 + 68px);
  color: #ffffff;
  text-align: center;
}

.d2-hero::before {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(8, 29, 61, 0.2), transparent 50%, rgba(7, 28, 60, 0.1));
  content: "";
}

.d2-hero-copy {
  position: relative;
  z-index: 1;
  display: flex;
  width: min(820px, 100%);
  min-width: 0;
  flex-direction: column;
  align-items: center;
}

.d2-hero-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #8fb8e6;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.d2-hero-status span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #4c9df0;
  box-shadow: 0 0 0 4px rgba(76, 157, 240, 0.12);
}

.d2-hero h1,
.d2-hero-copy > p {
  margin: 0;
}

.d2-hero h1 {
  max-width: 760px;
  font-size: clamp(27px, 2.25vw, 38px);
  font-weight: 760;
  letter-spacing: -0.045em;
  line-height: 1.25;
}

.d2-hero-copy > p {
  max-width: 720px;
  margin-top: 13px;
  color: #c1cfdf;
  font-size: 14px;
  line-height: 1.65;
}

.d2-ai-search {
  display: flex;
  width: min(760px, 100%);
  min-height: 62px;
  box-sizing: border-box;
  align-items: center;
  gap: 13px;
  margin-top: 28px;
  border: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.97);
  padding: 7px 7px 7px 20px;
  box-shadow: 0 16px 38px rgba(1, 11, 29, 0.22);
  color: var(--d2-blue-700);
  text-align: left;
}

.d2-ai-search > i {
  flex: none;
  color: var(--d2-blue-600);
  font-size: 16px;
}

.d2-ai-search input {
  width: 100%;
  height: 46px;
  min-width: 0;
  flex: 1;
  appearance: none;
  border: 0 !important;
  border-radius: 13px;
  outline: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 4px !important;
  color: #162236 !important;
  font-size: 14px;
}

.d2-ai-search input::placeholder {
  color: #8896a9 !important;
}

.d2-ai-search input::-webkit-search-cancel-button {
  display: none;
}

.d2-ai-search button {
  display: inline-flex;
  min-height: 46px;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: 9px;
  border: 0;
  border-radius: 14px;
  background: var(--d2-blue-700);
  padding: 0 20px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 750;
}

.d2-ai-search button:hover:not(:disabled) {
  background: #0d55ad;
}

.d2-ai-search button:disabled {
  cursor: default;
  opacity: 0.45;
}

.d2-metrics {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 20px;
  margin: 0;
  overflow: visible;
  border: 0;
  border-radius: 0;
  background: #f3f7fc;
  padding-block: 48px;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
}

.d2-metrics article {
  display: flex;
  min-width: 0;
  min-height: 170px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e7edf5;
  border-radius: 26px;
  background: var(--d2-surface);
  padding: 24px 16px;
  box-shadow: 0 10px 30px rgba(32, 72, 119, 0.08);
  text-align: center;
}

.d2-metrics p,
.d2-metrics strong,
.d2-metrics em,
.d2-metrics small {
  margin: 0;
  font-style: normal;
}

.d2-metrics p {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #3d4c62;
  font-size: 14px;
  font-weight: 750;
}

.d2-metrics p i {
  color: #9ba8b9;
  font-size: 12px;
}

.d2-metric-value {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-top: 17px;
}

.d2-metrics strong {
  color: var(--d2-blue-700);
  font-size: 40px;
  font-weight: 800;
  letter-spacing: -0.055em;
  line-height: 1;
}

.d2-metrics em {
  margin-left: 5px;
  color: #718096;
  font-size: 13px;
  font-weight: 700;
}

.d2-metrics small {
  display: block;
  margin-top: 14px;
  overflow: hidden;
  color: var(--d2-muted);
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-quick-menu {
  position: fixed;
  top: 50%;
  right: 56px;
  z-index: 30;
  display: flex;
  width: 88px;
  box-sizing: border-box;
  flex-direction: column;
  overflow: hidden;
  transform: translateY(-50%);
  border: 1px solid #e1e7ef;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.97);
  padding: 12px 8px;
  box-shadow: 0 12px 34px rgba(11, 37, 70, 0.15);
  backdrop-filter: blur(10px);
}

.d2-quick-menu button {
  display: flex;
  min-height: 56px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 0;
  border-bottom: 1px solid #edf1f6;
  background: transparent;
  padding: 6px 2px;
  color: #5c697b;
  font-size: 12px;
  font-weight: 700;
}

.d2-quick-menu button:last-child {
  border-bottom: 0;
}

.d2-quick-menu button:hover,
.d2-quick-menu button:focus-visible {
  border-radius: 12px;
  outline: 0;
  background: #eef5fe;
  color: var(--d2-blue-700);
}

.d2-quick-menu i {
  color: var(--d2-blue-600);
  font-size: 14px;
}

.d2-quick-menu .is-top {
  color: var(--d2-blue-700);
}

.d2-section,
.d2-panel {
  border: 1px solid var(--d2-line);
  border-radius: 18px;
  background: var(--d2-surface);
}

.d2-section {
  margin-top: 0;
}

.d2-catalog {
  border: 0;
  border-radius: 0;
  padding-block: 34px 46px;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
}

.d2-catalog .d2-section-header {
  align-items: center;
  margin-bottom: 22px;
  border-bottom: 1px solid var(--d2-line-soft);
  padding: 0 6px 20px;
}

.d2-catalog .d2-type-summary {
  margin: 0 6px 22px;
}

.d2-catalog .d2-toolbar {
  border: 1px solid var(--d2-line);
  border-bottom: 0;
  border-radius: 16px 16px 0 0;
  background: #f8fafc;
}

.d2-catalog .d2-table-wrap {
  border: 1px solid var(--d2-line);
  border-radius: 0 0 16px 16px;
  box-shadow: 0 12px 30px rgba(31, 61, 98, 0.06);
}

.d2-section-header,
.d2-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.d2-section-header {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  padding: 24px 26px 18px;
  text-align: center;
}

.d2-section-header > div:first-child {
  grid-column: 2;
  justify-self: center;
}

.d2-section-header > .d2-text-action {
  grid-column: 3;
  justify-self: end;
}

.d2-section-header h2,
.d2-section-header span,
.d2-panel-header h2,
.d2-panel-header > span {
  margin: 0;
}

.d2-section-header h2,
.d2-panel-header h2 {
  color: var(--d2-ink);
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.35;
}

.d2-section-header h2 {
  font-size: clamp(22px, 1.75vw, 26px);
}

.d2-panel-header h2 {
  font-size: 21px;
}

.d2-section-header > div > span {
  display: block;
  margin-top: 4px;
  color: #778397;
  font-size: 12px;
}

.d2-kicker {
  margin: 0 0 4px;
  color: var(--d2-blue-700);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.d2-type-summary {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
  margin: 0 26px 18px;
  border: 0;
  background: transparent;
}

.d2-type-summary article {
  display: grid;
  min-width: 0;
  grid-template-columns: 30px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  border: 1px solid var(--d2-line-soft);
  border-radius: 14px;
  background: #f8fafc;
  padding: 12px;
}

.d2-type-icon {
  display: inline-flex;
  width: 28px;
  height: 28px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eaf2fc;
  color: var(--d2-blue-700);
  font-size: 12px;
}

.d2-type-summary strong,
.d2-type-summary small,
.d2-type-summary b {
  display: block;
  min-width: 0;
  margin: 0;
}

.d2-type-summary strong {
  overflow: hidden;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-type-summary small {
  margin-top: 2px;
  color: var(--d2-muted);
  font-size: 12px;
}

.d2-type-summary b {
  color: var(--d2-blue-700);
  font-size: 12px;
  white-space: nowrap;
}

.d2-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  border-top: 1px solid var(--d2-line-soft);
  padding: 14px 26px;
}

.d2-filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.d2-filter {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  padding: 0 10px;
  color: #657287;
  font-size: 12px;
  font-weight: 700;
}

.d2-filter small {
  color: #94a0b1;
  font-size: 12px;
}

.d2-filter:hover {
  background: #f4f7fb;
}

.d2-filter.is-active {
  border-color: #b7d0ee;
  background: #edf5ff;
  color: #135eac;
}

.d2-filter.is-active small {
  color: #376fa9;
}

.d2-search {
  display: flex;
  width: min(350px, 42%);
  min-width: 260px;
  height: 36px;
  box-sizing: border-box;
  align-items: center;
  gap: 9px;
  border: 1px solid var(--d2-line);
  border-radius: 11px;
  background: #ffffff;
  padding: 0 11px;
  color: #93a0b3;
}

.d2-search:focus-within {
  border-color: #7aa8dc;
  box-shadow: 0 0 0 2px rgba(36, 117, 203, 0.08);
}

.d2-search input {
  min-width: 0;
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--d2-ink);
  font-size: 12px;
}

.d2-search input::placeholder {
  color: #9ca7b8;
}

.d2-search button {
  border: 0;
  background: transparent;
  padding: 2px;
  color: #8793a6;
}

.d2-table-wrap {
  overflow-x: auto;
  border-top: 1px solid var(--d2-line-soft);
}

.d2-table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
  table-layout: fixed;
}

.d2-table th,
.d2-table td {
  box-sizing: border-box;
  border-bottom: 1px solid var(--d2-line-soft);
  padding: 14px 16px;
  text-align: left;
  vertical-align: middle;
}

.d2-table th {
  background: #f7f9fc;
  color: #667388;
  font-size: 12px;
  font-weight: 800;
}

.d2-table th:first-child,
.d2-table td:first-child {
  width: 29%;
  padding-left: 26px;
}

.d2-table th:nth-child(2),
.d2-table td:nth-child(2) {
  width: 13%;
}

.d2-table th:nth-child(3),
.d2-table td:nth-child(3) {
  width: 17%;
}

.d2-table th:nth-child(4),
.d2-table td:nth-child(4) {
  width: 9%;
}

.d2-table th:nth-child(5),
.d2-table td:nth-child(5) {
  width: 22%;
}

.d2-table th:last-child,
.d2-table td:last-child {
  width: 10%;
  padding-right: 26px;
}

.d2-table tbody tr:last-child td {
  border-bottom: 0;
}

.d2-table tbody tr:hover {
  background: #fafcff;
}

.d2-table .is-number {
  text-align: right;
}

.d2-table .is-number strong {
  color: var(--d2-ink);
  font-size: 13px;
}

.d2-table .is-number span {
  margin-left: 2px;
  color: var(--d2-muted);
  font-size: 12px;
}

.d2-dataset {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-items: center;
  gap: 10px;
  overflow: hidden;
}

.d2-dataset > div {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.d2-dataset-mark {
  width: 7px;
  height: 7px;
  flex: none;
  border: 2px solid #c8def7;
  border-radius: 50%;
  background: var(--d2-blue-600);
}

.d2-dataset strong,
.d2-dataset p {
  display: block;
  margin: 0;
}

.d2-dataset strong {
  color: #263348;
  font-size: 12px;
  font-weight: 750;
}

.d2-dataset p {
  width: 100%;
  max-width: 100%;
  margin-top: 3px;
  overflow: hidden;
  color: #8994a5;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-table td:first-child {
  overflow: hidden;
}

.d2-type,
.d2-role,
.d2-status {
  display: inline-flex;
  min-height: 23px;
  box-sizing: border-box;
  align-items: center;
  border: 1px solid #d2deec;
  border-radius: 8px;
  background: #f4f7fb;
  padding: 0 7px;
  color: #43617f;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.d2-type-timeseries,
.d2-type-master,
.d2-type-knowledge,
.d2-type-event {
  border-color: #d7e0ea;
  background: #f6f8fb;
  color: #51657c;
}

.d2-role-list,
.d2-connections {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.d2-role {
  border-color: #d8e4f1;
  background: #f4f8fc;
  color: #3f668e;
}

.d2-role-training {
  border-color: #c8dcf3;
  background: #edf5fe;
  color: #155da7;
}

.d2-role-analysis {
  background: #f7f8fa;
  color: #5f6d7d;
}

.d2-connections code {
  display: inline-flex;
  min-height: 23px;
  align-items: center;
  border: 1px solid #dde3eb;
  border-radius: 7px;
  background: #fafbfd;
  padding: 0 6px;
  color: #647286;
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 12px;
}

.d2-status {
  position: relative;
  gap: 5px;
  border-color: transparent;
  background: transparent;
  padding: 0;
}

.d2-status::before {
  width: 6px;
  height: 6px;
  flex: none;
  border-radius: 50%;
  background: #91a0b2;
  content: "";
}

.d2-status-ready {
  color: #237454;
}

.d2-status-ready::before {
  background: #38a878;
}

.d2-status-review {
  color: #89621d;
}

.d2-status-review::before {
  background: #b98525;
}

.d2-status-progress {
  color: var(--d2-blue-700);
}

.d2-status-progress::before {
  background: var(--d2-blue-600);
}

.d2-status-empty {
  color: #7b8798;
}

.d2-empty {
  display: flex;
  min-height: 230px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--d2-line-soft);
  color: #8592a4;
  text-align: center;
}

.d2-empty > i {
  margin-bottom: 12px;
  color: #aac0d8;
  font-size: 25px;
}

.d2-empty strong,
.d2-empty p {
  margin: 0;
}

.d2-empty strong {
  color: var(--d2-ink);
  font-size: 13px;
}

.d2-empty p {
  margin-top: 4px;
  font-size: 12px;
}

.d2-empty button {
  min-height: 31px;
  margin-top: 12px;
  border: 1px solid #cbd8e6;
  border-radius: 10px;
  background: #ffffff;
  padding: 0 11px;
  color: var(--d2-blue-700);
  font-size: 12px;
  font-weight: 700;
}

.d2-operations-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
  gap: 20px;
  margin: 0;
  background: #eef3f8;
  padding-block: 26px 46px;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
}

.d2-operations-heading {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex-direction: column;
  margin: 0;
  background: #eef3f8;
  padding-top: 46px;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
  text-align: center;
}

.d2-operations-heading h2,
.d2-operations-heading > p:last-child {
  margin: 0;
}

.d2-operations-heading h2 {
  color: var(--d2-ink);
  font-size: clamp(22px, 1.75vw, 26px);
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.35;
}

.d2-operations-heading > p:last-child {
  max-width: 720px;
  margin-top: 5px;
  color: #778397;
  font-size: 12px;
  line-height: 1.55;
}

.d2-panel {
  min-width: 0;
  padding: 24px 26px;
}

.d2-panel-header {
  align-items: center;
  padding-bottom: 17px;
  border-bottom: 1px solid var(--d2-line-soft);
}

.d2-panel-header > span:not(.d2-status) {
  color: #7b8798;
  font-size: 12px;
}

.d2-training-policy {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 17px;
  border: 1px solid var(--d2-line-soft);
  border-radius: 12px;
  background: #fafbfd;
  overflow: hidden;
}

.d2-training-policy > div {
  min-width: 0;
  border-right: 1px solid var(--d2-line-soft);
  padding: 12px;
}

.d2-training-policy > div:last-child {
  border-right: 0;
}

.d2-training-policy small,
.d2-training-policy strong {
  display: block;
  overflow: hidden;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-training-policy small {
  color: #8490a1;
  font-size: 12px;
}

.d2-training-policy strong {
  margin-top: 4px;
  color: #334258;
  font-size: 12px;
}

.d2-profile-list {
  margin-top: 16px;
}

.d2-profile-list article + article {
  margin-top: 14px;
}

.d2-profile-list header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 7px;
}

.d2-profile-list strong,
.d2-profile-list span,
.d2-profile-list b {
  display: block;
  margin: 0;
}

.d2-profile-list strong {
  color: #2b394f;
  font-size: 12px;
}

.d2-profile-list span {
  margin-top: 2px;
  color: #8a95a5;
  font-size: 12px;
}

.d2-profile-list b {
  color: #4f5f74;
  font-size: 12px;
  white-space: nowrap;
}

.d2-progress {
  height: 3px;
  overflow: hidden;
  background: #e5eaf0;
}

.d2-progress i {
  display: block;
  height: 100%;
  background: var(--d2-blue-600);
}

.d2-source-list {
  margin-top: 8px;
}

.d2-source-list article {
  display: grid;
  min-width: 0;
  grid-template-columns: 32px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid var(--d2-line-soft);
  padding: 12px 0;
}

.d2-source-list article:last-child {
  border-bottom: 0;
}

.d2-source-icon {
  display: inline-flex;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6e2ee;
  border-radius: 10px;
  background: #f5f8fc;
  color: #4877a9;
  font-size: 12px;
}

.d2-source-list strong,
.d2-source-list p,
.d2-source-list b {
  display: block;
  margin: 0;
}

.d2-source-list strong {
  overflow: hidden;
  color: #2f3d52;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-source-list p {
  margin-top: 2px;
  color: #8a95a5;
  font-size: 12px;
}

.d2-source-list b {
  color: #425168;
  font-size: 12px;
  white-space: nowrap;
}

.d2-capabilities {
  border: 0;
  border-radius: 0;
  padding: 34px 0 46px;
}

.d2-capabilities .d2-section-header {
  padding: 0 max(50px, (100% - 1200px) / 2 + 50px) 22px;
}

.d2-text-action {
  display: inline-flex;
  min-height: 33px;
  flex: none;
  align-items: center;
  gap: 8px;
  border: 1px solid #cbd8e7;
  border-radius: 10px;
  background: #ffffff;
  padding: 0 11px;
  color: var(--d2-blue-700);
  font-size: 12px;
  font-weight: 700;
}

.d2-text-action:hover {
  border-color: #8fb5df;
  background: #f7faff;
}

.d2-connection-map {
  position: relative;
  display: grid;
  width: min(100% - 100px, 1120px);
  min-height: 380px;
  grid-template-columns: 30% 40% 30%;
  margin: 4px auto 0;
}

.d2-connection-lines {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
  pointer-events: none;
}

.d2-connection-lines path {
  fill: none;
  stroke: #9cc8f5;
  stroke-dasharray: 4 8;
  stroke-linecap: round;
  stroke-width: 2;
  vector-effect: non-scaling-stroke;
}

.d2-connection-lines circle {
  fill: #247ce0;
  filter: drop-shadow(0 0 5px rgba(36, 124, 224, 0.68));
  vector-effect: non-scaling-stroke;
}

.d2-connection-stack {
  position: relative;
  z-index: 2;
  display: flex;
  min-width: 0;
  height: 380px;
  flex-direction: column;
}

.d2-connection-stack.is-left {
  justify-content: space-between;
}

.d2-connection-stack.is-right {
  justify-content: space-between;
  box-sizing: border-box;
  padding: 23px 0;
}

.d2-connection-stack article {
  position: relative;
  display: grid;
  min-width: 0;
  min-height: 106px;
  box-sizing: border-box;
  grid-template-columns: 58px minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  border: 1px solid #dfe7f0;
  border-radius: 18px;
  background: #ffffff;
  padding: 16px 19px;
  box-shadow: 0 7px 20px rgba(34, 66, 105, 0.08);
}

.d2-connection-stack article::after {
  position: absolute;
  top: 50%;
  z-index: 3;
  width: 10px;
  height: 10px;
  border: 2px solid #ffffff;
  border-radius: 50%;
  background: #247ce0;
  box-shadow: 0 0 0 3px rgba(36, 124, 224, 0.1), 0 0 8px rgba(36, 124, 224, 0.58);
  content: "";
  transform: translateY(-50%);
}

.d2-connection-stack.is-left article::after {
  right: -7px;
}

.d2-connection-stack.is-right article::after {
  left: -7px;
}

.d2-connection-icon {
  display: inline-flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #edf5ff;
  color: #1d72d5;
  font-size: 23px;
}

.d2-connection-copy {
  min-width: 0;
}

.d2-connection-copy code,
.d2-connection-copy p,
.d2-connection-state strong {
  display: block;
  margin: 0;
}

.d2-connection-copy code {
  overflow: hidden;
  color: #223149;
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 13px;
  font-weight: 750;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-connection-copy p {
  margin-top: 6px;
  overflow: hidden;
  color: #7d8999;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.d2-connection-state {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 8px;
  white-space: nowrap;
}

.d2-connection-state strong {
  color: #27374e;
  font-size: 13px;
}

.d2-agent-core {
  position: relative;
  z-index: 2;
  display: flex;
  width: 220px;
  height: 220px;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
  border: 1px solid #d5e6fb;
  border-radius: 50%;
  background: radial-gradient(circle at 50% 35%, #ffffff 0%, #ffffff 56%, #f5f9ff 100%);
  box-shadow: 0 16px 38px rgba(36, 105, 183, 0.13), inset 0 0 30px rgba(63, 139, 226, 0.04);
}

.d2-agent-orbit {
  position: absolute;
  border: 1px solid rgba(52, 132, 221, 0.13);
  border-radius: 50%;
  pointer-events: none;
}

.d2-agent-orbit.is-outer {
  width: 286px;
  height: 286px;
}

.d2-agent-orbit.is-inner {
  width: 250px;
  height: 250px;
  border-style: dashed;
}

.d2-agent-core-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
}

.d2-agent-icon {
  display: inline-flex;
  width: 66px;
  height: 66px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #d7e4f3;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 7px 18px rgba(35, 94, 157, 0.11);
}

.d2-agent-icon img {
  display: block;
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.d2-agent-core-content strong {
  margin-top: 13px;
  color: #18263a;
  font-size: 19px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.d2-agent-core-content p {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin: 8px 0 0;
  color: #21815b;
  font-size: 13px;
  font-weight: 750;
}

.d2-agent-core-content p span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #32aa79;
  box-shadow: 0 0 0 4px rgba(50, 170, 121, 0.1);
}

.d2-agent-core-content small {
  margin-top: 7px;
  color: #8a96a7;
  font-size: 11px;
}

.d2-risk {
  display: block;
  margin: 0;
  border: 0;
  background: #f2f6fb;
  padding-block: 46px 52px;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
}

.d2-risk-header {
  display: flex;
  max-width: 720px;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  text-align: center;
}

.d2-risk-header h2,
.d2-risk-header > p:last-child {
  margin: 0;
}

.d2-risk-header h2 {
  color: var(--d2-ink);
  font-size: clamp(22px, 1.75vw, 26px);
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.35;
}

.d2-risk-header > p:last-child {
  margin-top: 5px;
  color: #778397;
  font-size: 12px;
  line-height: 1.55;
}

.d2-risk-icon {
  display: inline-flex;
  width: 42px;
  height: 42px;
  flex: none;
  align-items: center;
  justify-content: center;
  border: 1px solid #d5e4f5;
  border-radius: 14px;
  background: #edf5ff;
  color: var(--d2-blue-700);
  font-size: 16px;
}

.d2-risk-list {
  display: grid;
  width: min(100%, 1200px);
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin: 26px auto 0;
}

.d2-risk-list article {
  display: flex;
  min-width: 0;
  min-height: 184px;
  box-sizing: border-box;
  flex-direction: column;
  border: 1px solid #dce6f1;
  border-radius: 18px;
  background: #ffffff;
  padding: 20px;
  box-shadow: 0 9px 24px rgba(31, 66, 108, 0.06);
}

.d2-risk-list article.is-review {
  border-color: #e1d7bd;
}

.d2-risk-list article header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.d2-risk-label {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  border: 1px solid #d8e1eb;
  border-radius: 8px;
  background: #f7f9fb;
  padding: 0 8px;
  color: #6d798a;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.d2-risk-list article.is-review .d2-risk-icon {
  border-color: #e6dcc4;
  background: #faf6ec;
  color: #8b6728;
}

.d2-risk-list article.is-review .d2-risk-label {
  border-color: #ded1b2;
  background: #faf7f0;
  color: #866221;
}

.d2-risk-list strong,
.d2-risk-list p {
  display: block;
  margin: 0;
}

.d2-risk-list strong {
  margin-top: 18px;
  color: #344258;
  font-size: 14px;
  font-weight: 780;
  line-height: 1.4;
}

.d2-risk-list p {
  margin-top: 8px;
  color: #8490a0;
  font-size: 12px;
  line-height: 1.65;
}

.d2-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: var(--d2-navy-950);
  padding-block: 24px;
  padding-inline: max(24px, (100% - 1200px) / 2 + 24px);
  color: #8ea0b5;
  font-size: 12px;
}

.d2-footer-brand {
  color: #b9c8d8;
  font-weight: 800;
  letter-spacing: 0.12em;
}

@media (max-width: 1260px) {
  .d2-hero {
    padding: 36px 60px;
  }
  .d2-metrics article {
    padding: 24px 14px;
  }
  .d2-type-summary article {
    grid-template-columns: 26px minmax(0, 1fr);
  }
  .d2-type-summary b {
    grid-column: 2;
  }
  .d2-connection-stack article {
    grid-template-columns: 50px minmax(0, 1fr) auto;
    gap: 10px;
    padding: 13px;
  }
  .d2-connection-icon {
    width: 50px;
    height: 50px;
  }
  .d2-quick-menu {
    display: none;
  }
}
@media (max-width: 1100px) {
  .d2-quick-menu {
    display: none;
  }
}
@media (max-width: 1023px) {
  .d2-shell {
    padding: 0;
  }
  .d2-hero {
    padding: 36px 54px;
  }
  .d2-metrics {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    padding: 28px 18px;
  }
  .d2-type-summary {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .d2-toolbar {
    align-items: stretch;
    flex-direction: column;
    gap: 10px;
  }
  .d2-search {
    width: 100%;
    min-width: 0;
  }
  .d2-operations-grid {
    grid-template-columns: minmax(0, 1fr);
    padding: 24px 18px 40px;
  }
  .d2-operations-heading {
    padding-top: 36px;
    padding-right: 18px;
    padding-left: 18px;
  }
  .d2-risk {
    padding: 36px 42px 40px;
  }
  .d2-catalog {
    padding: 34px 18px 40px;
  }
  .d2-capabilities .d2-section-header {
    padding-right: 44px;
    padding-left: 44px;
  }
  .d2-connection-map {
    width: calc(100% - 88px);
  }
  .d2-footer {
    padding-right: 18px;
    padding-left: 18px;
  }
}
@media (max-width: 900px) {
  .d2-connection-map {
    min-height: 0;
    grid-template-columns: minmax(0, 1fr);
    gap: 14px;
    padding-top: 18px;
  }
  .d2-connection-lines {
    display: none;
  }
  .d2-connection-stack article::after {
    display: none;
  }
  .d2-agent-core {
    order: -1;
    width: 190px;
    height: 190px;
    margin: 28px auto 36px;
  }
  .d2-agent-orbit.is-outer {
    width: 250px;
    height: 250px;
  }
  .d2-agent-orbit.is-inner {
    width: 220px;
    height: 220px;
  }
  .d2-connection-stack,
  .d2-connection-stack.is-right {
    height: auto;
    gap: 12px;
    padding: 0;
  }
  .d2-risk-list {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 719px) {
  .d2-shell {
    padding: 0;
  }
  .d2-notice {
    grid-template-columns: auto minmax(0, 1fr);
    margin: 12px;
  }
  .d2-notice button {
    grid-column: 2;
    justify-self: start;
  }
  .d2-section-header {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
  .d2-section-header > div:first-child,
  .d2-section-header > .d2-text-action {
    grid-column: 1;
    justify-self: center;
  }
  .d2-hero {
    min-height: auto;
    border-radius: 0;
    background-position: 38% center;
    padding: 30px 36px;
  }
  .d2-hero h1 {
    font-size: 27px;
  }
  .d2-metrics {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    padding: 22px 12px;
  }
  .d2-metrics article:last-child {
    grid-column: 1/-1;
  }
  .d2-ai-search {
    min-height: 56px;
    padding-left: 16px;
  }
  .d2-ai-search button {
    min-height: 42px;
    padding: 0 16px;
  }
  .d2-section-header,
  .d2-panel-header {
    flex-direction: column;
  }
  .d2-section-header,
  .d2-panel {
    padding-right: 18px;
    padding-left: 18px;
  }
  .d2-catalog {
    padding: 30px 12px 34px;
  }
  .d2-catalog .d2-section-header {
    padding-right: 18px;
    padding-left: 18px;
  }
  .d2-type-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-right: 18px;
    margin-left: 18px;
  }
  .d2-catalog .d2-type-summary {
    margin-right: 18px;
    margin-left: 18px;
  }
  .d2-toolbar {
    padding-right: 18px;
    padding-left: 18px;
  }
  .d2-filter-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .d2-filter {
    justify-content: center;
  }
  .d2-training-policy {
    grid-template-columns: minmax(0, 1fr);
  }
  .d2-training-policy > div {
    border-right: 0;
    border-bottom: 1px solid var(--d2-line-soft);
  }
  .d2-training-policy > div:last-child {
    border-bottom: 0;
  }
  .d2-source-list article {
    grid-template-columns: 32px minmax(0, 1fr) auto;
  }
  .d2-source-list .d2-status {
    grid-column: 2/-1;
  }
  .d2-capabilities .d2-section-header {
    padding-right: 30px;
    padding-left: 30px;
  }
  .d2-connection-map {
    width: calc(100% - 60px);
  }
  .d2-risk-list {
    grid-template-columns: minmax(0, 1fr);
  }
  .d2-operations-grid {
    padding: 22px 12px 32px;
  }
  .d2-operations-heading {
    padding-top: 32px;
    padding-right: 24px;
    padding-left: 24px;
  }
  .d2-risk {
    padding: 32px 36px 36px;
  }
  .d2-footer {
    padding: 22px 12px;
  }
}
@media (max-width: 430px) {
  .d2-metrics,
  .d2-type-summary {
    grid-template-columns: minmax(0, 1fr);
  }
  .d2-metrics article:last-child {
    grid-column: auto;
  }
  .d2-ai-search {
    flex-wrap: wrap;
    padding: 12px;
  }
  .d2-ai-search input {
    min-height: 36px;
  }
  .d2-ai-search button {
    width: 100%;
  }
  .d2-capabilities .d2-section-header {
    padding-right: 18px;
    padding-left: 18px;
  }
  .d2-connection-map {
    width: calc(100% - 24px);
  }
  .d2-connection-stack article {
    min-height: 112px;
    grid-template-columns: 44px minmax(0, 1fr);
    padding: 13px 14px;
  }
  .d2-connection-icon {
    width: 44px;
    height: 44px;
    border-radius: 13px;
    font-size: 19px;
  }
  .d2-connection-state {
    grid-column: 2;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
  .d2-risk {
    padding-right: 12px;
    padding-left: 12px;
  }
  .d2-footer {
    align-items: flex-start;
    flex-direction: column;
  }
}
:host-context(html[data-theme=dark]) .d2-shell {
  --d2-ink: #edf3fa;
  --d2-text: #b0bdcc;
  --d2-muted: #7f8da0;
  --d2-line: #2b394b;
  --d2-line-soft: #263445;
  --d2-canvas: #0b1421;
  --d2-surface: #121e2d;
}

:host-context(html[data-theme=dark]) .d2-metrics article,
:host-context(html[data-theme=dark]) .d2-type-summary article,
:host-context(html[data-theme=dark]) .d2-toolbar,
:host-context(html[data-theme=dark]) .d2-table tbody,
:host-context(html[data-theme=dark]) .d2-risk {
  background: var(--d2-surface);
}

:host-context(html[data-theme=dark]) .d2-type-summary,
:host-context(html[data-theme=dark]) .d2-training-policy,
:host-context(html[data-theme=dark]) .d2-connection-stack article,
:host-context(html[data-theme=dark]) .d2-table th {
  background: #172434;
}

:host-context(html[data-theme=dark]) .d2-search,
:host-context(html[data-theme=dark]) .d2-text-action,
:host-context(html[data-theme=dark]) .d2-empty button {
  background: #162334;
  color: #8fc1f1;
}

:host-context(html[data-theme=dark]) .d2-quick-menu {
  border-color: #334255;
  background: rgba(18, 30, 45, 0.97);
}

:host-context(html[data-theme=dark]) .d2-quick-menu button {
  border-bottom-color: #2b394b;
  color: #aebdce;
}

:host-context(html[data-theme=dark]) .d2-metrics p {
  color: #d7e2ee;
}

:host-context(html[data-theme=dark]) .d2-table tbody tr:hover,
:host-context(html[data-theme=dark]) .d2-filter:hover {
  background: #162536;
}

:host-context(html[data-theme=dark]) .d2-dataset strong,
:host-context(html[data-theme=dark]) .d2-training-policy strong,
:host-context(html[data-theme=dark]) .d2-profile-list strong,
:host-context(html[data-theme=dark]) .d2-source-list strong,
:host-context(html[data-theme=dark]) .d2-connection-copy code,
:host-context(html[data-theme=dark]) .d2-connection-state strong,
:host-context(html[data-theme=dark]) .d2-agent-core-content strong,
:host-context(html[data-theme=dark]) .d2-risk-list strong {
  color: #dce6f1;
}

:host-context(html[data-theme=dark]) .d2-connection-stack article,
:host-context(html[data-theme=dark]) .d2-agent-core {
  border-color: #304056;
}

:host-context(html[data-theme=dark]) .d2-agent-core {
  background: radial-gradient(circle at 50% 35%, #18283a 0%, #142233 62%, #111d2c 100%);
}

:host-context(html[data-theme=dark]) .d2-connection-icon,
:host-context(html[data-theme=dark]) .d2-agent-icon {
  background: #1b3450;
  color: #79b8f4;
}

:host-context(html[data-theme=dark]) .d2-risk-icon {
  border-color: #31506f;
  background: #1b3450;
  color: #79b8f4;
}

:host-context(html[data-theme=dark]) .d2-risk-label {
  border-color: #35465a;
  background: #182536;
  color: #a8bad0;
}

:host-context(html[data-theme=dark]) .d2-risk-list article.is-review .d2-risk-icon,
:host-context(html[data-theme=dark]) .d2-risk-list article.is-review .d2-risk-label {
  border-color: #675a3f;
  background: #2c291f;
  color: #d9bd7c;
}

:host-context(html[data-theme=dark]) .d2-connections code,
:host-context(html[data-theme=dark]) .d2-type,
:host-context(html[data-theme=dark]) .d2-role {
  border-color: #35465a;
  background: #182536;
  color: #a8bad0;
}

:host-context(html[data-theme=dark]) .d2-metrics,
:host-context(html[data-theme=dark]) .d2-operations-heading,
:host-context(html[data-theme=dark]) .d2-operations-grid,
:host-context(html[data-theme=dark]) .d2-risk {
  background: #0b1523;
}

:host-context(html[data-theme=dark]) .d2-catalog,
:host-context(html[data-theme=dark]) .d2-capabilities,
:host-context(html[data-theme=dark]) .d2-risk-list article {
  background: var(--d2-surface);
}

:host-context(html[data-theme=dark]) .d2-risk-list article {
  border-color: var(--d2-line);
}`],
})
export class PageDashboard2Component implements OnInit {
    public overviewError: string = '';
    public usingFallback: boolean = false;
    public loadedAt: string = '-';

    public summary: any = {};
    public dataContext: any = {};
    public datasets: any[] = [];
    public modelTraining: any = {};
    public agentSources: any[] = [];
    public agentConnections: any[] = [];
    public risks: any[] = [];

    public datasetQuery: string = '';
    public datasetRole: string = 'all';
    public agentQuestion: string = '';
    public roleFilters: any[] = [
        { id: 'all', label: '전체' },
        { id: 'reference', label: 'Agent 참조' },
        { id: 'training', label: '학습' },
        { id: 'analysis', label: '분석 근거' },
    ];

    constructor(@Inject( Service) public service: Service) {
        this.applyOverview(this.fallbackOverview());
    }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        await this.load();
    }

    public async load() {
        this.overviewError = '';
        this.usingFallback = false;
        await this.service.render();

        try {
            const response: any = await wiz.call('overview');
            if (response?.code !== 200 || !response?.data) {
                throw new Error(response?.message || `응답 코드 ${response?.code || '없음'}`);
            }
            this.applyOverview(response.data);
        } catch (error: any) {
            this.applyOverview(this.fallbackOverview());
            this.usingFallback = true;
            const detail = typeof error?.message === 'string' && error.message !== '[object Object]'
                ? ` (${error.message})`
                : '';
            this.overviewError = `최신 집계를 불러오지 못해 내장 Agent 샘플 카탈로그를 표시합니다${detail}.`;
        } finally {
            this.loadedAt = this.formatDateTime(new Date());
            await this.service.render();
        }
    }

    private applyOverview(data: any) {
        const fallback = this.fallbackOverview();
        this.summary = data.summary || fallback.summary;
        this.dataContext = data.dataContext || fallback.dataContext;
        this.datasets = Array.isArray(data.datasets) ? data.datasets : fallback.datasets;
        this.modelTraining = data.modelTraining || fallback.modelTraining;
        this.agentSources = Array.isArray(data.agentSources) ? data.agentSources : fallback.agentSources;
        this.agentConnections = Array.isArray(data.agentConnections) ? data.agentConnections : fallback.agentConnections;
        this.risks = Array.isArray(data.risks) ? data.risks : fallback.risks;
    }

    private fallbackOverview() {
        const datasets = [
            { id: 'process-history', name: '공정 실행 이력', description: '공정 조건·결과 검색과 샘플 모델 학습 입력', type: '정형 데이터', typeKey: 'structured', roles: ['reference', 'training', 'analysis'], connections: ['process.search', 'trace.compare', 'model.predict', 'semiconductor.data'], recordCount: 42, status: 'ready', statusLabel: '사용 가능', owner: 'Process Intelligence', fields: ['lot', 'recipe', 'equipment', 'yieldScore'] },
            { id: 'sensor-trace', name: '센서 시계열', description: '장비 신호 이상 탐지와 RCA 근거', type: '시계열', typeKey: 'timeseries', roles: ['reference', 'analysis'], connections: ['trace.compare', 'semiconductor.data'], recordCount: 40, status: 'ready', statusLabel: '사용 가능', owner: 'Equipment Data', fields: ['sensor', 'window', 'baseline', 'trend'] },
            { id: 'metrology-quality', name: '계측·품질 결과', description: '두께·CD·결함·균일도의 Agent 원본 조회 문맥', type: '정형 데이터', typeKey: 'structured', roles: ['reference'], connections: ['semiconductor.data'], recordCount: 30, status: 'ready', statusLabel: '사용 가능', owner: 'Metrology', fields: ['metric', 'value', 'target', 'status'] },
            { id: 'equipment-master', name: '장비 마스터', description: '장비·챔버·담당 조직 기본 참조 정보', type: '마스터 데이터', typeKey: 'master', roles: ['reference'], connections: ['semiconductor.data'], recordCount: 16, status: 'ready', statusLabel: '사용 가능', owner: 'Equipment Data', fields: ['vendor', 'chamber', 'recipe', 'owner'] },
            { id: 'recipe-knowledge', name: 'Recipe 지식', description: '공정 목표와 제어 파라미터 참조', type: '지식 데이터', typeKey: 'knowledge', roles: ['reference'], connections: ['semiconductor.data'], recordCount: 15, status: 'ready', statusLabel: '사용 가능', owner: 'Process Integration', fields: ['target', 'parameters', 'controls'] },
            { id: 'lot-trace', name: 'Lot 추적 정보', description: '제품·공정 경로·수율의 Lot 단위 검색 문맥', type: '정형 데이터', typeKey: 'structured', roles: ['reference'], connections: ['semiconductor.data'], recordCount: 12, status: 'ready', statusLabel: '사용 가능', owner: 'Manufacturing Data', fields: ['product', 'route', 'currentStep', 'status'] },
            { id: 'center-line-master', name: '센터·라인 정보', description: '센터 위치·연구 분야·데이터 소유자 문맥', type: '마스터 데이터', typeKey: 'master', roles: ['reference'], connections: ['semiconductor.data'], recordCount: 5, status: 'ready', statusLabel: '사용 가능', owner: 'Data Governance', fields: ['location', 'focus', 'equipmentIds', 'dataOwner'] },
            { id: 'event-alarm-log', name: '이벤트·알람 로그', description: '장비 이벤트와 알람의 Agent 원본 조회 문맥', type: '이벤트 로그', typeKey: 'event', roles: ['reference'], connections: ['semiconductor.data'], recordCount: 16, status: 'ready', statusLabel: '사용 가능', owner: 'Equipment Data', fields: ['time', 'equipment', 'severity', 'message'] },
        ];

        return {
            summary: {
                totalDatasets: 8,
                totalRecords: 176,
                readyDatasets: 8,
                dataTypeCount: 5,
                capabilityCount: 5,
                modelCount: 2,
                usableTrainingRows: 28,
                referenceChunks: 3,
                connectedSourceCount: 2,
            },
            dataContext: {
                modeLabel: 'AI Agent 샘플',
                basisTime: '2026-05-18',
                freshnessLabel: '정적 샘플',
                source: 'Semiconductor Dummy Dataset · Agent Dataset Adapter',
            },
            datasets,
            modelTraining: {
                status: 'ready',
                statusLabel: '학습 가능',
                sourceDataset: '공정 실행 이력',
                sourceRecords: 42,
                usableRecords: 28,
                maxRowsPerRun: 12,
                fitMode: '요청마다 로컬 재학습',
                profiles: [
                    { modelId: 'vm-thickness', sourceRecords: 42, usableRecords: 28, criteria: '온도·압력·전력·시간·두께' },
                    { modelId: 'etch-endpoint-anomaly', sourceRecords: 42, usableRecords: 42, criteria: '압력·전력·시간' },
                ],
            },
            agentSources: [
                { id: 'structured-sample', name: '반도체 구조화 샘플', type: '도구 기반 참조·학습', itemCount: 176, unit: '건', status: 'connected', statusLabel: 'Agent 연결', description: '8종의 공정·장비 데이터를 Agent 조회와 모델 학습에 연결합니다.' },
                { id: 'built-in-rag', name: '내장 참조 지식', type: '문서 RAG', itemCount: 3, unit: 'chunks', status: 'connected', statusLabel: 'RAG 연결', description: '근거가 포함된 반도체 가이드 샘플을 검색에 사용합니다.' },
                { id: 'approved-documents', name: '승인 사용자 문서', type: 'ACL 적용 문서 RAG', itemCount: 0, unit: 'chunks', status: 'empty', statusLabel: '등록 없음', description: '읽기 권한이 확인된 승인 문서만 집계합니다.' },
                { id: 'user-dataset-store', name: '사용자 데이터셋 저장소', type: '버전형 행 데이터', itemCount: 0, unit: 'rows', status: 'empty', statusLabel: '등록 없음', description: '저장 데이터와 Agent 질의 어댑터를 분리해 관리합니다.' },
            ],
            agentConnections: [
                { capability: 'semiconductor.data', name: '반도체 데이터 전체 조회', description: '8개 구조화 컬렉션을 원본 필드와 함께 Agent 문맥으로 제공', datasetCount: 8, readyCount: 8, readiness: 100, status: 'ready', statusLabel: '연결됨' },
                { capability: 'process.search', name: '공정 데이터 검색', description: '자연어 조건을 공정 이력 필터와 원본 레코드 조회로 연결', datasetCount: 1, readyCount: 1, readiness: 100, status: 'ready', statusLabel: '연결됨' },
                { capability: 'trace.compare', name: 'Trace 파형 비교', description: '공정 이력과 센서 시계열을 기준 파형과 비교', datasetCount: 2, readyCount: 2, readiness: 100, status: 'ready', statusLabel: '연결됨' },
                { capability: 'model.predict', name: '샘플 모델 예측', description: '공정 이력에서 요청별 학습 표본을 선택해 로컬 모델 실행', datasetCount: 1, readyCount: 1, readiness: 100, status: 'ready', statusLabel: '연결됨' },
                { capability: 'rag.search', name: '근거 문서 검색', description: '내장 샘플과 승인 문서 chunk를 검색', datasetCount: 1, readyCount: 1, readiness: 100, status: 'ready', statusLabel: '연결됨' },
            ],
            risks: [
                { title: '작은 학습 표본', detail: '요청마다 최대 12개 샘플 행을 선택하므로 검증 지표가 불안정할 수 있습니다.', level: 'review' },
                { title: '정적 샘플 데이터', detail: '운영 최신성을 나타내지 않으며 Agent 기능 검증 용도로만 사용합니다.', level: 'info' },
                { title: '운영 모델 대체 불가', detail: '샘플 모델 결과를 생산 판정이나 공정 제어 근거로 사용하면 안 됩니다.', level: 'info' },
                { title: '조회 범위와 자동 입력 구분', detail: '개별 질의에는 선택된 Agent 도구의 데이터만 투입됩니다.', level: 'info' },
            ],
        };
    }

    public summaryCards() {
        return [
            { label: '전체 데이터셋', value: this.summary.totalDatasets || 0, unit: '종', detail: '통합 데이터 카탈로그', icon: 'fa-layer-group' },
            { label: 'Agent 참조', value: this.roleDatasetCount('reference'), unit: '종', detail: '구조화 조회 · 문서 RAG', icon: 'fa-book-open' },
            { label: '모델 학습', value: this.roleDatasetCount('training'), unit: '종', detail: '로컬 모델 학습 입력', icon: 'fa-microchip' },
            { label: '데이터 유형', value: this.summary.dataTypeCount || 0, unit: '종', detail: '공정 데이터 분류 체계', icon: 'fa-diagram-project' },
            { label: '전체 레코드', value: this.summary.totalRecords || 0, unit: '건', detail: 'Agent 기능 검증 표본', icon: 'fa-database' },
        ];
    }

    public roleDatasetCount(role: string) {
        return (this.datasets || []).filter((item: any) => (item.roles || []).includes(role)).length;
    }

    public datasetTypeBreakdown() {
        const rows: any = {};
        for (const dataset of (this.datasets || [])) {
            const typeKey = String(dataset.typeKey || 'structured');
            if (!rows[typeKey]) {
                rows[typeKey] = { typeKey, label: dataset.type || typeKey, datasetCount: 0, recordCount: 0 };
            }
            rows[typeKey].datasetCount += 1;
            rows[typeKey].recordCount += Number(dataset.recordCount || 0);
        }
        return ['structured', 'timeseries', 'master', 'knowledge', 'event']
            .filter((key: string) => rows[key])
            .map((key: string) => rows[key]);
    }

    public datasetIcon(typeKey: string) {
        const icons: any = {
            structured: 'fa-table-list',
            timeseries: 'fa-wave-square',
            master: 'fa-server',
            knowledge: 'fa-book-open',
            event: 'fa-bell',
        };
        return icons[typeKey] || 'fa-database';
    }

    public connectionIcon(capability: string) {
        const icons: any = {
            'semiconductor.data': 'fa-database',
            'process.search': 'fa-magnifying-glass',
            'trace.compare': 'fa-wave-square',
            'model.predict': 'fa-chart-line',
            'rag.search': 'fa-book-open',
        };
        return icons[capability] || 'fa-link';
    }

    public filteredDatasets() {
        const query = String(this.datasetQuery || '').trim().toLowerCase();
        return (this.datasets || []).filter((item: any) => {
            const roleMatches = this.datasetRole === 'all' || (item.roles || []).includes(this.datasetRole);
            if (!roleMatches) return false;
            if (!query) return true;
            const haystack = [
                item.name,
                item.description,
                item.type,
                item.owner,
                ...(item.fields || []),
                ...(item.connections || []),
            ].join(' ').toLowerCase();
            return haystack.includes(query);
        });
    }

    public setDatasetRole(role: string) {
        this.datasetRole = role;
    }

    public clearDatasetFilters() {
        this.datasetQuery = '';
        this.datasetRole = 'all';
    }

    public roleFilterClass(role: string) {
        return this.datasetRole === role ? 'd2-filter is-active' : 'd2-filter';
    }

    public datasetTypeClass(type: string) {
        return `d2-type d2-type-${type || 'structured'}`;
    }

    public statusClass(status: string) {
        const state = ['ready', 'connected', 'complete', 'pass'].includes(status) ? 'ready'
            : ['review', 'unavailable'].includes(status) ? 'review'
            : ['progress', 'waiting'].includes(status) ? 'progress'
            : 'empty';
        return `d2-status d2-status-${state}`;
    }

    public roleClass(role: string) {
        return `d2-role d2-role-${role || 'reference'}`;
    }

    public roleLabel(role: string) {
        const labels: any = { reference: 'Agent 참조', training: '학습', analysis: '분석 근거' };
        return labels[role] || role;
    }

    public trainingProfiles() {
        return (this.modelTraining?.profiles || []).slice(0, 3);
    }

    public profilePercent(profile: any) {
        const total = Number(profile?.sourceRecords || 0);
        if (total <= 0) return 0;
        return Math.max(0, Math.min(100, Math.round((Number(profile?.usableRecords || 0) / total) * 100)));
    }

    public trainingModelName(model: string) {
        const names: any = {
            'vm-thickness': '두께 Virtual Metrology',
            'etch-endpoint-anomaly': '공정 이상 탐지',
            'sample-vm-thickness': '두께 Virtual Metrology',
            'sample-process-anomaly': '공정 이상 탐지',
            'sample-vm-thickness-v1': '두께 Virtual Metrology',
            'sample-process-anomaly-v1': '공정 이상 탐지',
        };
        return names[model] || model;
    }

    public riskLabel(level: string) {
        return level === 'review' ? '검토 필요' : '안내';
    }

    public governanceRisks() {
        const items = Array.isArray(this.risks) ? this.risks : [];
        if (items.length <= 3) return items;

        const combinedTitles = ['정적 샘플 데이터', '운영 모델 대체 불가'];
        const result: any[] = [];
        let combined = false;
        for (const item of items) {
            if (combinedTitles.includes(item?.title)) {
                if (!combined) {
                    result.push({
                        title: '검증용 샘플 데이터',
                        detail: '운영 최신성을 나타내지 않는 기능 검증용 샘플이며, 생산 판정이나 공정 제어 근거로 사용할 수 없습니다.',
                        level: 'info',
                    });
                    combined = true;
                }
                continue;
            }
            result.push(item);
        }
        return result.slice(0, 3);
    }

    public riskIcon(title: string) {
        const icons: any = {
            '작은 학습 표본': 'fa-flask',
            '검증용 샘플 데이터': 'fa-shield-halved',
            '정적 샘플 데이터': 'fa-clock-rotate-left',
            '운영 모델 대체 불가': 'fa-shield-halved',
            '조회 범위와 자동 입력 구분': 'fa-diagram-project',
        };
        return icons[title] || 'fa-circle-info';
    }

    public formatNumber(value: any) {
        const parsed = Number(value || 0);
        return Number.isFinite(parsed) ? parsed.toLocaleString('ko-KR') : String(value || '-');
    }

    public formatDateTime(value: Date) {
        const pad = (part: number) => String(part).padStart(2, '0');
        return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())} ${pad(value.getHours())}:${pad(value.getMinutes())}`;
    }

    public openDataHub() {
        this.service.href('/agent/history');
    }

    public openAgent() {
        this.service.href('/agent/chat');
    }

    public askNanoFab() {
        const question = String(this.agentQuestion || '').trim().slice(0, 2000);
        if (!question) return;
        try {
            sessionStorage.setItem('nanofab.agent.pending-question', question);
        } catch (_error) {
            // 제한된 브라우저 환경에서도 채팅 화면 이동은 유지합니다.
        }
        this.service.href('/agent/chat');
    }

    public scrollToSection(id: string) {
        if (typeof document === 'undefined') return;
        const target = document.getElementById(id);
        if (!target) return;
        const scrollSurface = document.querySelector('.d2l-main-surface, .nf-main-surface') as HTMLElement | null;
        if (scrollSurface && scrollSurface.contains(target)) {
            const targetTop = target.getBoundingClientRect().top;
            const surfaceTop = scrollSurface.getBoundingClientRect().top;
            scrollSurface.scrollTo({
                top: scrollSurface.scrollTop + targetTop - surfaceTop,
                behavior: 'smooth',
            });
            return;
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public scrollToTop() {
        if (typeof document === 'undefined') return;
        const scrollSurface = document.querySelector('.d2l-main-surface, .nf-main-surface') as HTMLElement | null;
        if (scrollSurface) {
            scrollSurface.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }
        if (typeof window !== 'undefined') window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export default PageDashboard2Component;